import auth from "@/auth/authService";
import apiendpoints from "@/../apiendpoints";

export default {
    isUserLoggedIn: () => {
        let isAuthenticated = false;
        return new Promise(async(resolve, reject) => {
            isAuthenticated = await auth.isAuthenticated();
            resolve(isAuthenticated!=false && localStorage.getItem('userInfo')!=null)
        })
    },
    apiendpoints: apiendpoints,
    userRole: localStorage.getItem("userRole") || 'public',
    userInfo: navigator.onLine ? null : localStorage.getItem("userInfo")
}